import styled from "styled-components";

/** Left text — these cells are prose. Middle vertical — row heights vary. */
export const ContentTable = styled.table`
  th,
  td {
    text-align: left;
    vertical-align: middle;
  }
`;
